
import {Link, useNavigate} from "react-router-dom"
import {
  ChevronLeft,
  ChevronRight,
  Copy,
  CreditCard,
  DeleteIcon,
  DownloadIcon,
  EllipsisVertical,
  File,
  Home,
  LineChart,
  ListFilter,
  MoreVertical,
  Package,
  Package2,
  PanelLeft,
  Search,
  Settings,
  ShoppingCart,
  Truck,
  Users2,
} from "lucide-react"

import { Badge } from "../../component/ui/badge"
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
  useBreadCrumb,
} from "../../component/ui/breadcrumb"
import { Button } from "../../component/ui/button"
import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from "../../component/ui/card"
import {
  DropdownMenu,
  DropdownMenuCheckboxItem,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "../../component/ui/dropdown-menu"
import { Input } from "../../component/ui/input"
import {
  Pagination,
  PaginationContent,
  PaginationItem,
} from "../../component/ui/Pagination"
import { Progress } from "../../component/ui/progress"
import { Separator } from "../../component/ui/separator"
import { Sheet, SheetContent, SheetTrigger } from "../../component/ui/sheet"
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../../component/table/table"
import {
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from "../../component/ui/tabs"
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "../../component/ui/tooltip"
import Overview from "../../component/investor/Overview"
import FundManagers from "../../component/investor/FundManagers"
import Performance from "../../component/investor/Performance"
import Portfolio from "../../component/investor/Portfolio"
import SchemeDocuments from "../../component/investor/SchemeDocuments"
import { DataTable } from "../../component/table/dataTable"
import { Dashboard } from "../investorPage/Dashboard"
import AdvancedDropdown from "../../component/ui/multi-selection-dropdown-menu-with-search"
import { useDispatch, useSelector } from "react-redux"
import { useEffect, useState } from "react"
import { IoIosArrowBack } from "react-icons/io"
import { nullAllSchemeDetails } from "../../context/actions/allSchemeDetailsAction"
import { FaRegEye } from "react-icons/fa"
export const description =
  "An orders dashboard with a sidebar navigation. The sidebar has icon navigation. The content area has a breadcrumb and search in the header. The main area has a list of recent orders with a filter and export button. The main area also has a detailed view of a single order with order details, shipping information, billing information, customer information, and payment information."

export function InvestorInfo({back,forWhichUserType}) {


    // const tabsList=[
    //     {label:"Overview",value:"overview",component:<Overview/>},
    //     {label:"Performance",value:"performance",component:<Performance/>},
    //     {label:"Fund Manager",value:"fundManager",component:<FundManagers/>},
    //     {label:"Portfolio",value:"portfolio",component:<Portfolio/>},
    //     {label:"Scheme Documents",value:"schemeDocuments",component:<SchemeDocuments/>}
    // ]
    const navigate=useNavigate()
    const dispatch=useDispatch()

    const [currentPage,setCurrentPage]=useState(1)
    const [totalPage,setTotalPage]=useState(1)
    const handleInvestorReportView = async (reportUrl) => {
      try {
        // Check if the report URL is valid before opening
        if (reportUrl) {
          // Open the report URL in a new tab
          window.open(reportUrl, "_blank");
        } else {
          console.log("Invalid report URL");
        }
      } catch (error) {
        console.log("Error in handleSchemeReportView function", error);
      }
    };
    

    const handleDownloadSchemeReport = async (reportUrl) => {
      try {
        // Check if the report URL is valid
        if (reportUrl) {
          // Create an anchor element
          const link = document.createElement("a");
          link.href = reportUrl;
          link.download = "scheme_report.pdf"; // Set the download filename
    
          // Append the link to the document, click it to trigger the download, and remove it
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        } else {
          console.log("Invalid report URL");
        }
      } catch (error) {
        console.log("Error in handleDownloadSchemeReport function", error);
      }
    };
    


    const buttonOptions = [
  
      
      {
        icon: <FaRegEye />,
        alt: "",
        text: <span className="text-base font-semibold">View</span>,
        iconHeight: 17,
        iconWidth: 17,
        iconColor: "black",
        name: "View",
        actionHandleInvestorReportView: handleInvestorReportView
      },
      // {
      //   icon: <IoMdDownload />,
      //   alt: "",
      //   text: <span className="text-base font-semibold">Download</span>,
      //   iconHeight: 17,
      //   iconWidth: 17,
      //   iconColor: "black",
      //   name: "Download",
      //   actionHandleDownloadSchemeReport: handleDownloadSchemeReport
      // },
    ];

    const columns = [
      { id: 'report_name', header: 'Report Name' },
      // { id: 'report_type', header: 'Report Type' },
      { id: 'created_at', header: 'Uploaded Date' },
      // { id: 'scheme', header: 'Scheme' },
      // { id: 'class', header: 'Class' },
    ];
 
    const [schemeAndClassOption,setSchemeAndClassOption]=useState(["Option 1","Option 2","Option 3"])
    const[selectedSchemeOptions,setSelectedSchemeOptions]=useState([])
    const investorInfo=useSelector(state=>state.investorInfo)
    useEffect(()=>{
    
      if(investorInfo){
        const schemeAndClass=investorInfo.schemes.map((item,index)=>(`${item.scheme_name}-${item.scheme_class}`))
        setSchemeAndClassOption(schemeAndClass)
      }
    },[investorInfo])
  
  
  
    useEffect(() => {
      if (schemeAndClassOption?.length > 0) {
        setSelectedSchemeOptions(schemeAndClassOption);
        console.log("setSelectedSchemeOptions updated with", schemeAndClassOption);
      }
    }, [schemeAndClassOption]); // Depend on the scheme state
  
    const tabsList=[
      {label:"Dashboard",value:"dashboard",component:<  Dashboard/>,},
      {label:"Reports",value:"reports",component:<DataTable  totalPage={totalPage} currentPage={currentPage} setCurrentPage={setCurrentPage}  buttonOptions={buttonOptions} selectedSchemeOptions={selectedSchemeOptions} tableFor="InvestorSchemeReport" columns={columns} />},
      
  ]
  return (
    <div className="flex min-h-screen w-full flex-col  ">
      
      <div className="flex flex-col sm:gap-4  sm:pl-1">
        {/* accessiblity fix for silktide issues - H1 heading */}
        <h1 className="sr-only">Investor Information</h1>
      <Button
        variant="outline"
        size="sm"
        className=" h-10  gap-1 text-sm w-max self-start "
        onClick={()=>{
          
          // dispatch(loaderSet(true))
         back()
         if(forWhichUserType==="distributor"){

           navigate("/distributor")
         }
         
        if(forWhichUserType==="employee"){
          navigate("/employee")
          

          dispatch(nullAllSchemeDetails())
          window.location.reload();
        }
        if(forWhichUserType==="admin"){
          navigate("/admin")
          dispatch(nullAllSchemeDetails())
          window.location.reload();
        }
        }
        } 
      >
        <IoIosArrowBack />
        Back
      </Button>
        <main className="grid flex-1 items-start gap-4  ">
          <div className="grid auto-rows-max items-start gap-4 md:gap-8  lg:col-span-2">
     
            <Tabs defaultValue="dashboard"  >
              <div className="flex bg-white items-center flex-col ">
               <div className=" flex  w-full flex-col items-start  mt-2" >
               <TabsList  className="  bg-white border-b-2 w-full rounded-md flex justify-start " >
                {
                    tabsList.map((curElem,index)=>(
                          <TabsTrigger key={index} value={curElem.value} tabIndex={index + 1} className="data-[state=active]:text-[#0D215C] data-[state=active]:font-bold " >{curElem.label}</TabsTrigger>
                    ))
                }
                  
                  {/* <TabsTrigger value="month" className="data-[state=active]:text-[#0D215C] data-[state=active]:font-bold " >Month</TabsTrigger>
                  <TabsTrigger value="year" className="data-[state=active]:text-[#0D215C] data-[state=active]:font-bold " >Year</TabsTrigger> */}
                </TabsList>
                <div className="w-full flex justify-between items-start p-2 rounded-md">
  <div className="flex w-full justify-end items-center gap-4">
    

    {/* Dropdown Menu */}
  
  </div>
</div>
              
               </div>
        

              </div>
            {
                tabsList.map((curElem,index)=>
                (
                    <TabsContent  key={index} value={curElem.value}>
                    <Card x-chunk="dashboard-05-chunk-3  ">
                    
                    {
                      curElem.value==="reports" &&
                      <>
                             <div className="flex w-full justify-end  items-center  ">

{/* Ticker name Input field */}
{/* Dropdown Menu */}
<div className="w-64 h-10 mr-5">
    <AdvancedDropdown
      name="Scheme"
      id="scheme"
      options={schemeAndClassOption}
      selectedOptions={selectedSchemeOptions}
      setSelectedOptions={setSelectedSchemeOptions}
      placeholder="Scheme"
      select={"single"}
      label={false}
    />
  </div>





</div>
                      </>
                    }

                      <CardContent className="bg-muted/40 pt-5" >
                        <div className=" w-full  flex justify-center items-center text-center  " ></div>
               {curElem.component}
    
                      
                      </CardContent>
                      
                      
                    </Card>
                  </TabsContent>
                )
                )
            }
            </Tabs>
          </div>
          <div>
         
          </div>
        </main>
      </div>
    
    </div>
  )
}
